<template>
    <div class="detail" id="detail">
      <!-- 课程详情 -->
       <app-header v-if="header_show"></app-header>
        <div class="content">
          <div class="crumbs_top">
            <p><span @click="toBack">首页></span><span @click="toBack">我的课程></span><span class="blue">{{course.courseName}}</span></p>
          </div>
          <div class="lesson">
              <div class="logo">
                <img :src="course.coverUrl" alt="">
              </div>
              <div class="intro">
                <div class="title">{{course.courseName}}</div>
                <div class="tags">
                  <div class="tag">{{views}}人学过</div>
                </div>
                <div class="detail">
                  <div class="left">
                   <!-- <p style="margin-bottom: 0.2rem;"><span>专题分类：{{course.tagname}} </span><span v-if="course.lable"> 课程类型：{{course.lable}}</span></p>-->
                    <p style="margin-bottom: 0.2rem;"><span>结业方式：{{course.assessMode==0?'课程测评':'观看视频'}} </span><span> 学时：{{course.coursePeriod}}</span></p>
                    <p>授课专家：{{lecturer.name}}</p>
                  </div>
                </div>
                <div class="point">
                  <div class="right">
                    <!-- <span class="make_point"  @click="sendEval">提交打分</span> -->
                    <span class="make_point"  @click="sendEval" v-if="evaled">
                      <img src="../assets/images/tijiaodafen.png" alt="">
                    </span>
                    <div class="stars">
                     <img :src="(index <= evalIndex ? require('../assets/images/lesson_stared.png'):require('../assets/images/lesson_star.png'))" v-for="index of 5" :key="index" @click="changeEval(index)" alt="">
                    </div>
                    <span class="text">课程评分：{{ups}}人评价</span>
                  </div>
                </div>
              </div>
          </div>
          <div class="step">
            <div class="step_bg">
              <div class="step_center" :style="{width:course.ratio+'%'}"></div>
            </div>
            <div v-if="course.assessMode == 0">
              <div v-if="course.status <= 1" class="tolearn" @click="toEval" style="margin-left: 0.2rem;">参加测评</div>
              <div v-if="course.status <= 1" class="tolearn" @click="toLearn">进入学习</div>

              <div v-if="course.status === 2" @click="goTest" class="tolearn">参加测评</div>
              <div v-if="course.status === 3" @click="goTest" class="tolearn">查看测评结果</div>
            </div>
            <div v-if="course.assessMode == 1">
              <div class="tolearn" @click="toLearn">进入学习</div>
            </div>
          </div>
          <div class="poinenum">目前已完成{{course.done}}个知识点</div>
          <div class="catalog">
            <div class="left">
              <div class="total">目录</div>
              <div :class="(item.status > 0 ? 'list nowList' : 'list')" v-for="(item,index) in segments" :key="index" @click="toLearned(item.status,index)">
                <img v-if="item.status <= 0" class="checked" src="../assets/images/learn.png" alt="">
                <img v-if="item.status > 0" class="checked" src="../assets/images/learned.png" alt="">
                <span class="title">{{item.segmentName}}</span>
                <span class="time">{{parseInt(item.segmentDuration) | hms}}</span>
                <div style="width: right;" v-if="item.status <= 0">
                  <img v-if="item.type == 0" class="type" src="../assets/images/lesson_videoG.png" alt="">
                  <img v-if="item.type == 1" class="type" src="../assets/images/lesson_audioG.png" alt="">
                  <img v-if="item.type == 2" class="type" src="../assets/images/lesson_imgG.png" alt="">
                </div>
                <div style="width: right;" v-if="item.status > 0">
                  <img v-if="item.type == 0" class="type" src="../assets/images/lesson_videoB.png" alt="">
                  <img v-if="item.type == 1" class="type" src="../assets/images/lesson_audioB.png" alt="">
                  <img v-if="item.type == 2" class="type" src="../assets/images/lesson_imgB.png" alt="">
                </div>
              </div>
            </div>
            <div class="right">
              <img class="head" :src="lecturer.photoUrl" alt="">
              <p class="name">{{lecturer.name}}</p>
              <p class="company">{{lecturer.unitName}}</p>
              <p class="intro">{{lecturer.introduce}}</p>
            </div>
          </div>
          <div class="note">
            <div class="left">
              <div class="total">我的笔记</div>
               <div class="list" v-for="(item,index) in noteList" :key="index">
                  <div style="border-bottom: 1px solid #6f6f6f;padding-bottom: 0.26rem;padding-top: 0.35rem;overflow: hidden;">
                    <p class="intro">{{item.content}}</p>
                    <div class="know">
                      <p class="know_point">
                        <img class="point_img" src="../assets/images/detail_point.png" alt="">
                        知识点：<span class="bold">{{item.segmentName}}</span>
                      </p>
                      <div class="method">
                        <span @click="delNote(item.id)">删除</span>
                        <img @click="delNote(item.id)" src="../assets/images/lesson_del.png" alt="">
                        <span @click="editNote(item.id,item.content)" style="margin-right: 0.4rem;">编辑</span>
                        <img @click="editNote(item.id,item.content)" src="../assets/images/lesson_edit.png" alt="">
                      </div>
                    </div>
                  </div>
               </div>
               <div class="note_page" v-if="allNote > 0">
                 <el-pagination
                   layout="prev, pager, next"
                   @current-change="handleNoteChange"
                   :total="allNote">
                 </el-pagination>
               </div>
            </div>
            <div class="right">
              <div class="total">讨论区</div>
              <div class="area">
                <textarea placeholder=" " v-model="guestContent"></textarea>
                <div class="btn" @click="addGuestBook">发布</div>
              </div>
              <div v-for="(item,index) in remarkList" :key ="index" class="list">
                <div class="user">
                  <img :src="item.photoUrl || require('../assets/images/head.png')" alt="">
                  <span class="username">{{item.guestTraineeName}}</span>
                  <span class="time">{{item.createTime}}</span>
                </div>
                <p class="intro">{{item.content}}</p>
                <div class="func">
                  <div :class="(item.status == 1 ? 'dianzan yizan' : 'dianzan')" @click="toUp(item)">
                    <span>({{item.ups || 0}})</span>
                    <img v-if="item.upStatus == 0" src="../assets/images/lesson_zan.png" alt="">
                    <img v-if="item.upStatus == 1" src="../assets/images/lesson_zaned.png" alt="">
                  </div>

                  <!-- <span style="margin-right: 0.28rem;">(567)</span> -->
                  <!-- <img src="../assets/images/lesson_comment.png" alt=""> -->
                </div>
                <!-- <div class="second">
                  <img class="head" src="../assets/images/head.png" alt="">
                  <textarea placeholder="输入评论..."></textarea>
                  <img class="detail_send" src="../assets/images/detail_send.png" alt="">
                  <p class="tips"> 全部评论（12）</p>
                  <div class="list">
                    <div class="user">
                      <img src="../assets/images/head.png" alt="">
                      <span class="username">张三</span>
                      <span class="time">2020-08-20</span>
                    </div>
                    <p class="intro">笔记内容笔记内容笔记内容笔记内容笔记内容笔记内容笔记内容笔记内容笔记内容笔记内容笔记内容笔记内容笔记内容笔记内容笔</p>
                  </div>
                </div> -->
              </div>
              <div class="talk_page" v-if="allTalk > 0">
                <el-pagination
                  layout="prev, pager, next"
                  @current-change="handleTalkChange"
                  :total="allTalk">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="masking" v-if="showMask">
          <div class="editmask" v-if="editType == 1">
            <div class="edit_top">
              <span>编辑笔记</span>
              <img @click="closeMasking" src="../assets/images/eval_close.png" alt="">
            </div>
            <div class="edit_con">
              <p class="know">知识点：中小学法律纠纷处理</p>
              <p class="text">笔记内容</p>
              <div>
                <textarea v-model="editContent"></textarea>
              </div>
            </div>
            <div class="btns">
              <div class="btn_sure" @click="saveNote">保存</div>
              <div class="btn_concel" @click="concelDel">取消</div>
            </div>
          </div>
          <div class="editmask" v-if="editType == 0">
            <div class="edit_top">
              <span>删除笔记</span>
              <img @click="closeMasking" src="../assets/images/eval_close.png" alt="">
            </div>
            <div class="edit_con">
              <p class="del_tip">删除后无法恢复，确定删除此条笔记吗？</p>
            </div>
            <div class="btns">
              <div class="btn_sure" @click="sureDel">删除</div>
              <div class="btn_concel" @click="concelDel">取消</div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
  import Header from '@/components/Header'
  export default {
    name: 'detail',
    components:{
      'app-header':Header,
    },
    data () {
      return {
        header_show:true,
        event:'',
        id:'',
        detail:'',
        segments:[],
        segment:'',
        noteList:[],
        notePage:1,
        guestBooks:[],
        course:[],
        segmentIndex:0,
        guestContent:'',

        newNote:'',
        showMask:false,
        editType:0,
        editId:'',
        editContent:'',
        userinfo:'',
        lecturer:{},
        views:0,
        ups:0,
        evalIndex:5,
        evaled:true,
        remarkList:[],
        talkPage:1,

        allTalk:0,
        allNote:0,
      }
    },
    mounted() {
      this.event = JSON.parse(localStorage.getItem('event'));
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
      this.id = this.$route.query.id;
      this.getDetail();
      console.log('89900')
      //this.getList();
      this.getGestList();
      this.getNoteList();
    },
    methods:{
      toUp(e){
        // 课程点赞
        console.log(e);
        var _this = this;
        if(e.upStatus == 1) return;
        var params = {
          guestbookId:e.guestBookId,
        }
        _this.post('/guestbook/upGuestBook',params,(data)=>{
          if(data.status == 200){
            _this.remarkList.forEach((v,k)=>{
              if(e.guestBookId == v.guestBookId){
                v.upStatus = 1;
                v.ups = parseInt(v.ups) +1;
              }
            })
            _this.$forceUpdate();
          }else{
            _this.$mResToast({
              type:'error',
              msg:data.msg,
              duration:4000,
              isIcon:true,
            });
          }
        })
      },
      toEval(){
        this.$mResToast({
          type:'error',
          msg:'请先完成课程学习再参与测评',
          duration:4000,
          isIcon:true,
        });
      },
      handleNoteChange(value){
        console.log(value,'value');
        this.notePage = value;
        this.getNoteList()
      },
      handleTalkChange(value){
        console.log(value,'value');
        this.talkPage = value;
        this.getGestList()
      },
      changeEval(index){
        if(!this.evaled) return;
        this.evalIndex = index;
      },
      getList(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,

        }
        _this.post('/course/course/listTopNew',params,(data)=>{
          console.log(data,'0099');
          _this.list = data.data;
        })
      },
      addGuestBook(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,
          courseId:_this.id,
          traineeId:_this.userinfo.traineeId,
          content:_this.guestContent,
        }
        this.post('/guestbook/addGuestBook',params,(data)=>{
          console.log(data);
          this.getGestList()
          _this.$mResToast({
            type:data.status == 200 ? 'success' : 'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
          if(data.status == 200){
            _this.guestContent = '';
          }
        })
      },
      saveNote(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,
          id:_this.editId,
          content:_this.editContent,
          page:this.page,
          limit:10,
          courseId:_this.id
        }
        this.post('/course/note/editCourseNote',params,(data)=>{
          console.log(data);
          // _this.$mResToast({
          //   type:data.status == 200 ? 'success' : 'error',
          //   msg:data.msg,
          //   duration:3000,
          //   isIcon:true,
          // });
          if(data.status == 200){
            _this.showMask = false;
            this.getDetail()
          }
        })
      },
      sureDel(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,
          id:_this.editId,
        }
        this.post('/course/note/delNote',params,(data)=>{
          console.log(data);
          // _this.$mResToast({
          //   type:data.status == 200 ? 'success' : 'error',
          //   msg:data.msg,
          //   duration:3000,
          //   isIcon:true,
          // });
          if(data.status == 200){
            _this.showMask = false;
            this.getDetail()
          }
        })
      },
      concelDel(){
        this.showMask = false;
      },
      closeMasking(){
        this.showMask = false;
      },
      editNote(id,content){
        this.editType = 1;
        this.editId = id;
        this.showMask = true;
        this.editContent = content;
      },
      delNote(id){
        this.editType = 0;
        this.editId = id;
        this.showMask = true;
      },
      header:function (bool) {
        this.header_show = bool;
      },
      toLearned(status = 1,index = 0){
        console.log(index);
        if(status == 1){
          this.$router.push({name:'Video',query:{id:this.id,index}});
        }
      },
      toLearn(){
        this.$router.push({name:'Video',query:{id:this.id}});
      },
      goTest(){
        this.$router.push({name:'Test',query:{id:this.id,tagName:this.course.courseName}})
      },
      getNoteList(){
        var _this = this;
        let params ={eventId:this.event.eventId,courseId:this.id,page:this.notePage,limit:10,}
        this.post('/course/note/courselist',params,(data)=>{
          console.log(data,'data')
          let datalist = data.data.list
          this.noteList = datalist;
          _this.allNote = parseFloat(data.data.totalCount);
        })
      },
      getGestList(){
        var _this = this;
        let params ={eventId:this.event.eventId,courseId:this.id,page:this.talkPage,limit:10}
        this.post('/guestbook/queryGestbook',params,(data)=>{
          // console.log(data,'data')
          let datalist = data.data.list
          for(let i=0;i< datalist.length;i++ ){
            let value = ''
            let date = new Date(datalist[i].createTime)
            value = date.getFullYear()
            value = value+'-'+ (date.getMonth()+1)
            value = value+'-'+ date.getDate()
            datalist[i].createTime = value
          }
          _this.allTalk = parseFloat(data.data.totalCount);
          this.remarkList = datalist;
        })
      },
      getDetail(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,
          courseId:+_this.id,
        }
        this.post('/course/course/info',params,(data)=>{
          console.log(data,'data------');
            _this.detail = data.data;
            // _this.notes = data.data.notes;
            // _this.guestBooks = data.data.guestBooks;
            _this.course = data.data.course;
            console.log(_this.course,'this.course')
            _this.segments = data.data.segments;
            _this.lecturer= data.data.lecturer
            _this.views = data.data.views
            _this.segment = data.data.segment;
            _this.ups = data.data.ups
           _this.evalIndex=data.data.course.rate
            if(data.data.segments.length > 0){
              _this.segments.forEach((v,k)=>{
                if(v.segmentId == data.data.segment.segmentId){
                  _this.segmentIndex = k;
                }
              })
            }
            _this.evalIndex = parseFloat(data.data.course.rate);
            if(_this.evalIndex > 0){
              _this.evaled = false;
            }else{
              _this.evaled = true;
            }
        })
      },
      sendEval(){
        var _this = this;
        var params = {
          eventId:_this.event.eventId,
          courseId:_this.id,
          rate:_this.evalIndex > 0 ? _this.evalIndex : 1,
        }
        this.post('/course/course/courseRate ',params,(data)=>{
          console.log(data);
          _this.$mResToast({
            type:data.status == 200 ? 'success' : 'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
          if(data.status == 200){
            _this.getDetail();
            // _this.evaled = false;
          }
        })
      },
      toBack(){
        this.$router.go(-1);
      },
    }
  }
</script>
<style scoped>
.note_page{
  float: left;
  height: 0.3rem;
  width: 80%;
  padding: 0.5rem 0.2rem 0.8rem 0.2rem;
}
.note_page >>> .el-pagination{
  float: left;
  width: 100%;
  height: 0.3rem;
}
.talk_page{
  float: right;
  height: 0.3rem;
  width: 100%;
  padding: 0.23rem 0 0.8rem;
}
.talk_page >>> .el-pagination{
  float: right;
  height: 0.3rem;
}





.masking{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,0.65);
}
.masking .editmask{
  width: 7.86rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background-color: #fff;
  border-radius: 0.1rem;
}
.masking .editmask .edit_top{
  width: 7.3rem;
  height: 1.1rem;
  margin: 0 auto;
  border-bottom: 0.01rem solid #767676;
}
.masking .editmask .edit_top span{
  font-size: 0.33rem;
  line-height: 1.1rem;
  color: #000;
  float: left;
  margin-left: 0.3rem;
}
.masking .editmask .edit_top img{
  float: right;
  width: 0.37rem;
  height: 0.35rem;
  margin-top: 0.4rem;
  cursor: pointer;
}
.masking .editmask .edit_con{
  width: 7.3rem;
  margin: 0 auto;
}
.masking .editmask .edit_con .know{
  margin-top: 0.22rem;
  text-indent: 0.3rem;
  text-align: left;
}
.masking .editmask .edit_con .text{
  margin-top: 0.16rem;
  text-indent: 0.3rem;
  text-indent: 0.3rem;
}
.masking .editmask .edit_con .del_tip{
  margin: 0.75rem;
  text-align: center;
}
.masking .editmask .edit_con textarea{
  width: 7.21rem;
  height: 1.89rem;
  display: block;
  margin: 0.2rem auto;
  font-size: 0.21rem;
  color: #000;
  padding: 0.14rem;
  outline: none;
  border: 0.01rem solid #404040;
}
.masking .editmask .edit_con p{
  font-size: 0.21rem;
  color: #000;
}
.masking .editmask .btns{
  width: 7.3rem;
  height: 0.6rem;
  margin: 0.25rem auto 0.34rem auto;
}
.masking .editmask .btns .btn_concel{
  float: right;
  font-size: 0.24rem;
  color: #fff;
  width: 1.38rem;
  height: 0.59rem;
  background-color: #b4b4b4;
  text-align: center;
  line-height: 0.59rem;
  margin-right: 0.31rem;
  cursor: pointer;
}
.masking .editmask .btns .btn_sure{
  float: right;
  font-size: 0.24rem;
  color: #fff;
  width: 1.38rem;
  height: 0.59rem;
  background-color: #2b73cc;
  text-align: center;
  line-height: 0.59rem;
  cursor: pointer;
}




.content{
  width: 15rem;
  max-width: 100%;
  margin: 0 auto;
}
.content .crumbs_top {
  width: 100%;
  height: 0.89rem;
  line-height: 0.89rem;
}
.content .crumbs_top p{
  float: left;
  text-indent: 0.32rem;
  width: 100%;
  height: 0.89rem;
  line-height: 0.89rem;
  margin-bottom: 0.1rem;
}
.content .crumbs_top p span{
  font-size: 0.25rem;
  color: #414141;
   line-height: 0.89rem;
   float: left;
   cursor: pointer;
}
.content .crumbs_top p .blue{
  color: #2b73cc;
}
.content .lesson{
  width: 100%;
  height: 3.6rem;
}
.content .lesson .logo{
  float: left;
  width: 5.33rem;
  height: 2.92rem;
  margin: 0.3rem 0.36rem 0 0.85rem;
}
.content .lesson .logo img{
  width: 100%;
  height: 100%;
  float: left;
}
.content .lesson .intro{
  width: 8.4rem;
  max-width: 100%;
  float: left;
}
.content .lesson .intro .title{
  font-size: 0.33rem;
  color: #181818;
  margin-top: 0.4rem;
  border-left: 0.08rem solid #0073d3;
  padding-left: 0.27rem;

  overflow: hidden;
  text-overflow: ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:2;

}
.content .lesson .intro .tags{
  width: 100%;
  height: 0.35rem;
  margin-top: 0.12rem;
  padding-left: 0.27rem;
}
.content .lesson .intro .tags .tag{
  font-size: 0.2rem;
  color: #757575;
  float: left;
  padding: 0.06rem 0.24rem;
  border-radius: 0.18rem;
}

.content .lesson .intro .detail{
  width: 100%;
  margin-top: 0.3rem;
  padding-left: 0.28rem;
}
.content .lesson .intro .detail .left{
  float: left;
  position: relative;
  display: inline-block;
}
.content .lesson .intro .detail .left p{
  float: left;
  font-size: 0.25em;
  color: #414141;
  width: 100%;
  height: 0.26rem;
  line-height: 0.26rem;
}
.content .lesson .intro .detail .left p span{
  margin-right: 0.28rem;
}
.content .lesson .intro .detail .btn{
  width: 2rem;
  height: 0.5rem;
  color: #fff;
  background-color: #2b73cc;
  font-size: 0.25rem;
  text-align: center;
  line-height: 0.5rem;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}

.point{
  float: left;
  width: 100%;
  height: 0.24rem;
  padding-left: 0.28rem;
  margin-top: 0.3rem;
}
.point .right{
  float: left;
}
.point .right .text{
  font-size: 0.17rem;
  color: #414141;
  float: right;
  margin-right: 0.19rem;
  line-height: 0.24rem;
}
.point .right .stars{
  float: right;
  height: 0.24rem;
  line-height: 0.24rem;
}
.point .right .stars img{
  float: right;
  width: 0.24rem;
  height: 0.23rem;
  margin-right: 0.06rem;
  float: left;
}
.point .right .make_point{
  float: right;
  /* font-size: 0.17rem; */
  /* color: #414141; */
  margin-left: 0.49rem;
  /* padding: 0.02rem 0.16rem; */
  /* border: 1px solid #414141; */
  cursor: pointer;
  width: 1.14rem;
  height: 0.23rem;
}
.point .right .make_point img{
  float: left;
  width: 1.14rem;
  height: 0.23rem;
}
.content .step{
  width: 100%;
  height: 0.45rem;
  margin: 0.1rem 0 0.2rem 0;
  padding-left: 0.3rem;
  box-sizing: border-box;
}
.content .step .step_bg{
  width: 10.4rem;
  max-width: 100%;
  height: 0.2rem;
  float: left;
  background-color: #c5c5c5;
  border-radius: 0.07rem;
  margin-top: 0.13rem;
  /* margin-left: 0.3rem; */
  margin-bottom: 0.1rem;
  position: relative;
}
.content .step .step_center{
  width: 0;
  height: 100%;
  z-index: 9;
  background-color: #0073d3;
  border-radius: 0.07rem;
  position: absolute;
  left: 0;
}
.content .tolearn{
  float: right;
  width: 1.76rem;
  height: 0.45rem;
  font-size: 0.25rem;
  text-align: center;
  line-height: 0.45rem;
  background-color: #2b73cc;
  color: #fff;
  cursor: pointer;
}
.poinenum{
  float: left;
  width: 100%;
  height: 0.2rem;
  font-size: 0.17rem;
  color: #414141;
  text-indent: 0.3rem;
}

.catalog{
  width: 100%;
  float: left;
  margin-top: 0.56rem;
}
.catalog .total{
  float: left;
  font-size: 0.42rem;
  height: 0.42rem;
  line-height: 0.42rem;
  color: #414141;
  padding-left: 0.2rem;
  margin-left: 0.28rem;
  margin-bottom: 0.26rem;
  border-left: 0.08rem solid #0073d3;
}
.catalog .left{
  width: 10.33rem;
  max-width: 100%;
  float: left;
}
.catalog .left .list{
  width: calc(100% - 0.58rem);
  height: 0.43rem;
  margin: 0 0 0 0.58rem;
  float: left;
  border-bottom: 1px solid #6f6f6f;
  padding-right: 0.1rem;
  box-sizing: border-box;
  cursor: pointer;
}
.catalog .left .list .checked{
  float: left;
  width: 0.2rem;
  height: 0.2rem;
  margin: 0.12rem 0.2rem 0 0.16rem;
}
.catalog .left .list .title{
  font-size: 0.25rem;
  color: #6f6f6f;
  float: left;
  line-height: 0.43rem;
  max-width: 8rem;

  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.catalog .left .list .type{
  float: right;
  width: 0.22rem;
  height: 0.22rem;
  margin: 0.11rem 0.2rem 0 0;
}
.catalog .left .list .time{
  font-size: 0.2rem;
  color: #414141;
  float: right;
  line-height: 0.44rem;
  /* margin-right: 0.1rem; */
}
.catalog .nowList .title{
  color: #2b73cc !important;
}
.catalog .nowList .time{
  color: #2b73cc !important;
}



.catalog .right{
  width: 3.75rem;
  float: right;
}
.catalog .right .head{
  width: 3.73rem;
  height: 1.78rem;
  float: right;
}
.catalog .right .name{
  float: left;
  width: 100%;
  font-size: 0.33rem;
  color: #414141;
  text-align: center;
  margin-top: 0.26rem;
}
.catalog .right .company{
  float: left;
  width: 100%;
  font-size: 0.25rem;
  color: #414141;
  text-align: center;
  margin-top: 0.1rem;
}
.catalog .right .intro{
  float: left;
  width: 100%;
  font-size: 0.25rem;
  color: #414141;
  margin-top: 0.2rem;
}



.note{
  width: 100%;
  float: left;
  margin-top: 0.8rem;
}
.note .left{
  width: 10.35rem;
  max-width: 100%;
  float: left;
}
.note .left .total{
  float: left;
  font-size: 0.42rem;
  height: 0.42rem;
  line-height: 0.42rem;
  color: #414141;
  padding-left: 0.14rem;
  margin-left: 0.24rem;
  margin-bottom: 0.26rem;
  border-left: 0.08rem solid #0073d3;
}
.note .left .list{
  float: left;
  width: 10.06rem;
  max-width: 100%;
  /* margin-left: 0.53rem; */
  padding-left: 0.53rem;
  /* border-bottom: 1px solid #6f6f6f; */
}
.note .left .list .intro{
  font-size: 0.25rem;
  color: #767676;
}
.note .left .list .know{
  float: left;
  width: 100%;
  line-height: 0.28rem;
  margin-top: 0.4rem;
}
.note .left .list .know .know_point{
  float: left;
  font-size: 0.25rem;
  color: #3d3d3d;
  max-width: 7.6rem;
}
.note .left .list .know .know_point .point_img{
  width: 0.27rem;
  height: 0.35rem;
  float: left;
  margin-top: -0.04rem;
  margin-right: 0.04rem;
}
.note .left .list .know .know_point .bold{
  font-weight: 700;
}


.note .left .list .know .method{
  float: right;
  cursor: pointer;
}
.note .left .list .know .method img{
  float: right;
  width: 0.26rem;
  height: 0.26rem;
  margin-right: 0.1rem;
}
.note .left .list .know .method span{
  float: right;
  font-size: 0.25rem;
  color: #3d3d3d;
}




.note .right{
  width: 4rem;
  float: right;
  position: relative;
}
.note .right .total{
  float: left;
  font-size: 0.42rem;
  height: 0.42rem;
  line-height: 0.42rem;
  color: #414141;
  padding-left: 0.2rem;
  margin-bottom: 0.26rem;
  border-left: 0.08rem solid #0073d3;
  position: absolute;
  left: -0.22rem;
  top: 0;
}
.note .right .area{
  width: 4rem;
  float: right;
  margin-top: 0.65rem;
  border-bottom: 0.01rem solid #828282;
  padding-bottom: 0.17rem;
}
.note .right .area textarea{
  width: 3.9rem;
  height: 2rem;
  float: right;
  border: 1px solid #767676;
  outline: none;
  font-size: 0.17rem;
  color: #414141;
  padding: 0.06rem 0.04rem;
  resize: none;
}
.note .right .area .btn{
  font-size: 0.24rem;
  color: #fff;
  width: 0.98rem;
  height: 0.32rem;
  background-color: #2b73cc;
  float: right;
  text-align: center;
  line-height: 0.32rem;
  margin-top: 0.1rem;
  cursor: pointer;
}
.note .right .list .user{
  width: 100%;
  height: 0.8rem;
}
.note .right .list .user img{
  width: 0.53rem;
  height: 0.53rem;
  float: left;
  margin-top: 0.13rem;
}
.note .right .list .user .username{
  font-size: 0.21rem;
  color: #414141;
  float: left;
  line-height: 0.8rem;
  margin-left: 0.16rem;
  width: 2.2rem;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.note .right .list .user .time{
  font-size: 0.17rem;
  color: #828282;
  float: right;
  line-height: 0.8rem;
}

.note .right .list{
  float: left;
  width: 4rem;
  border-bottom: 1px solid #828282;
  margin-top: 0.2rem;
}
.note .right .list .intro{
  font-size: 0.17rem;
  color: #828282;
  padding-bottom: 0.1rem;
}
.note .right .list .func{
  width: 100%;
  height: 0.17rem;
  line-height: 0.17rem;
  margin: 0.24rem 0 0.13rem 0;
}

.note .right .list .func .dianzan{
  -webkit-user-select: none;
   -moz-user-select: none;
   -ms-user-select: none;
   user-select: none;
}
.note .right .list .func .dianzan.yizan{
  color: #2b73cc;
}

.note .right .list .func span{
  font-size: 0.18rem;
  color: #828282;
  float: right;
  cursor: pointer;
}
.note .right .list .func img{
  width: 0.17rem;
  height: 0.17rem;
  float: right;
  margin-right: 0.08rem;
  cursor: pointer;
}
.note .right .list .second{
  width: 3.54rem;
  float: right;
  margin-top: 0.4rem;
  padding-bottom: 0.25rem;
  position: relative;
}
.note .right .list .second .head{
  float: left;
  margin-top: 0.3rem;
}
.note .right .list .second .list{
  border-bottom: 0;
  width: 100%;
  float: left;
}
.note .right .list .second .list .username{
  width: 1.8rem;
}
.note .right .list .second textarea{
  width: 2.88rem;
  height: 1.3rem;
  outline: none;
  resize: none;
  border: 1px solid #7c7c7c;
  float: right;
  padding: 0.12rem 0.15rem 0.3rem 0.15rem;
}
.note .right .list .second .detail_send{
  width: 0.18rem;
  height: 0.18rem;
  position: absolute;
  right: 0.11rem;
  top: 0.96rem;
  cursor: pointer;
}

.note .right .list .second .tips{
  font-size: 0.17rem;
  color: #828282;
  float: left;
  margin-left: 0.66rem;
}
/* .point .right .make_point{
  float: right;
  font-size: 0.17rem;
  color: #414141;
  margin-left: 0.49rem;
  padding: 0.02rem 0.16rem;
  border: 1px solid #414141;
  cursor: pointer;
} */
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue